<template>
	<div>
		<div style="display: flex;align-items: center;justify-content: space-between;">
			<a-breadcrumb style="margin: 16px 0">
				<a-breadcrumb-item>主页</a-breadcrumb-item>
				<a-breadcrumb-item>运行数据</a-breadcrumb-item>
				<a-breadcrumb-item>刷卡记录</a-breadcrumb-item>
			</a-breadcrumb>
			<div>
				<!-- <a-button class="qinang-button-margin" icon="plus" @click="addVisible = true">新增</a-button>
				<a-button class="qinang-button-margin" icon="edit" @click="tableEdit">修改</a-button>
				<a-button class="qinang-button-margin" icon="delete" @click="tableDel">删除</a-button> -->
				<a-button icon="sync" @click="apiSwipeQueryList">刷新</a-button>
			</div>
		</div>
		
		<a-collapse expandIconPosition="right" activeKey="1">
			<a-collapse-panel key="1" header="条件查询">
				<div class="qinang-search-row">
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">电梯名称：</div>
						<a-input v-model="query.elevatorName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">卡名称：</div>
						<a-input v-model="query.cardName" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
					<div class="qinang-search-col-3">
						<div class="qinang-search-col-title">卡号：</div>
						<a-input v-model="query.cardNo" style="width: 100%;" placeholder="请输入名称关键字查询" />
					</div>
				</div>
				<div class="qinang-margin-top-12 qinang-search-row" style="justify-content: center;">
					<a-button type="primary" icon="search" @click="apiSwipeQueryList">查询</a-button>
					<a-button icon="redo" @click="resetChange" style="margin-left: 14px;">重置</a-button>
				</div>
			</a-collapse-panel>
		</a-collapse>
		
		<div class="qinang-card">
			<a-table :columns="tableColumns" :data-source="tableData" row-key="companyId" :loading="tableLoading" :pagination="false">
				<span slot="companyName" slot-scope="companyName">
					<a-button type="link" @click="edit(companyName)" >{{companyName.companyName}}</a-button>
				</span>
				<span slot="cardName" slot-scope="cardName">
					{{cardName.cardName}}
					<span style="color: #aaa;">[{{cardName.cardNo}}]</span>
				</span>
				<span slot="swipeState" slot-scope="swipeState">
					<span v-if="swipeState.swipeState == 2" style="color: #f5222d;">失败</span>
					<span v-if="swipeState.swipeState == 3" style="color: #52c41a;">成功</span>
				</span>
				<span slot="swipeTime" slot-scope="swipeTime">
					<!-- {{moment(swipeTime).format('YYYY-MM-DD HH:mm:ss')}} -->
					{{qaUtil.timeFormat(swipeTime.swipeTime)}}
				</span>
				<span slot="tableAction" slot-scope="tableAction">
					<a-button type="link" @click="codeReset(tableAction)">动态码重置</a-button>
				</span>
			</a-table>
			<a-pagination style="text-align: right;margin: 10px;" :current="query.page" :total="query.total" :default-page-size="query.size" show-size-changer show-quick-jumper size="small" :page-size-options="['10', '20', '50']"
				:show-total="total => `共 ${total} 条记录`" @change="pageChange" @showSizeChange="showSizeChange"/>
		</div>

		
		
	</div>
</template>

<script>
	import moment from 'moment'
	export default {
		data() {
			return {
				moment,
				// 搜索+表格-start
				query: {
					page: 1,
					size: 10,
					total: 0,
					elevatorName: '',
					cardName: '',
					cardNo: '',
					swipeState: 0,
				},
				tableData: [],
				tableColumns: [
					{ title:'ID', dataIndex:'swipeId', key:'swipeId', align:'center'},
					{ title:'电梯', key:'elevatorName', dataIndex:'elevatorName', align:'center'},
					{ 
						title:'电梯卡', 
						key:'cardName', 
						align:'center', 
						scopedSlots: {
							customRender: 'cardName'
						}},
					{ title:'刷卡动态码', key:'dyCodeRead', dataIndex:'dyCodeRead',align:'center'},
					{ title:'正确动态码', key:'dyCodeReal', dataIndex:'dyCodeReal',align:'center'},
					{ title:'可通行楼层', key:'usableFloor', dataIndex:'usableFloor',align:'center'},
					{ title:'刷卡状态', key:'swipeState',align:'center', scopedSlots:{customRender:'swipeState'}},
					{ title:'状态描述', key:'swipeMsg', dataIndex:'swipeMsg',align:'center'},
					{ title:'刷卡时间', key:'swipeTime', align:'center', scopedSlots:{customRender:'swipeTime'}},
					{
						title: '操作',
						key: 'tableAction',
						align: 'center',
						scopedSlots: {
							customRender: 'tableAction'
						}
					},
					
				],
				tableLoading: false,
				tableSelectedRows: {},
				//搜索+表格-end
			};
		},
		methods: {
			//重置
			resetChange() {
				this.query = {
					page: 1,
					size: 10,
					total: 0,
					companyName: '',
				}
			},
			//表格开始-搜索
			async apiSwipeQueryList() {
				this.tableLoading = true
				const {
					data: res
				} = await this.$http.post(this.navigation.apiSwipeQueryList, this.query);
				if (res.code == 200) {
					this.tableData = res.data.list
					this.query.page = res.data.pages.page
					this.query.size = res.data.pages.size
					this.query.total = res.data.pages.total
					this.tableLoading = false
				} else {
					this.$message.error(res.msg)
					this.tableLoading = false
				}
			},
			pageChange(page, pageSize){
				this.query.page = page
				this.query.size = pageSize
				this.apiSwipeQueryList()
			},
			showSizeChange(current, size){
				this.query.page = current
				this.query.size = size
				this.apiSwipeQueryList()
			},
			//动态码重置
			async codeReset(item) {
				let that = this
				this.$confirm({
					title: '确定重置动态码吗？',
					okText: '确定',
					okType: 'primary',
					cancelText: '取消',
					onOk() {
						that.apiCardDyCodeResetBySwipe(item)
					},
					onCancel() {
					},
				});
			},
			//动态码重置
			async apiCardDyCodeResetBySwipe(item) {
				const {
					data: res
				} = await this.$http.post(this.navigation.apiCardDyCodeResetBySwipe, {cardNo: item.cardNo});
				if (res.code == 200) {
					this.$message.success(res.msg)
				} else {
					this.$message.error(res.msg)
				}
			},
			
			
			
		},
		computed: {
		},
		created() {
			this.apiSwipeQueryList()
		}
	};
</script>

<style scoped>
	
</style>
